'use client';

import styles from '@/components/audit/ProReportResults.module.css';

interface ReportFooterProps {
  reportId: string;
}

export function ReportFooter({ reportId }: ReportFooterProps) {
  return (
    <footer className={styles.reportFooter}>
      <p>
        Powered by <strong>Interface Audit</strong> - 167 research-backed Audit Criteria
      </p>
      <p className={styles.footerMeta}>Report ID: {reportId}</p>
    </footer>
  );
}
